import { Box, Button, MenuItem, InputLabel, Menu } from "@mui/material";
import PropTypes from "prop-types";
import { useState, useMemo } from "react";
import BlogPostStatusBadge from "./BlogPostStatusBadge.jsx";
import { useBlogPostActions } from "hooks/useBlogPostActions.jsx";
import React from "react";

BlogPostStatusChanger.propTypes = {
  blogPost: PropTypes.object.isRequired,
  onStatusChange: PropTypes.func,
};

const STATS = [
  {
    value: "draft",
    label: "Entwurf",
  },
  {
    value: "review",
    label: "In Prüfung",
  },
  {
    value: "released",
    label: "Freigegeben",
  },
  {
    value: "published",
    label: "Veröffentlicht",
  },
];

/**
 * Komponente zum Ändern des Status eines BlogPost
 *
 * @param blogPost
 * @param onStatusChange
 * @returns {React.JSX.Element|null}
 * @constructor
 */
export default function BlogPostStatusChanger({ blogPost, onStatusChange }) {
  const { updateBlogPostStatus } = useBlogPostActions();

  const currentStatusObject = STATS.find((f) => f.value === blogPost?.status); // Ursprünglicher Status
  const possibleTransitions = STATS;

  const statusOptions = useMemo(() => {
    const allOptions = [];
    if (currentStatusObject) {
      allOptions.push(currentStatusObject);
    }
    if (possibleTransitions) {
      allOptions.push(...possibleTransitions);
    }
    const uniqueOptions = allOptions.reduce((acc, current) => {
      if (!acc.find((item) => item.value === current.value)) {
        acc.push(current);
      }
      return acc;
    }, []);
    return uniqueOptions;
  }, [currentStatusObject, possibleTransitions]);

  const [status, setStatus] = useState(
    currentStatusObject || { value: "", label: "" }
  );

  const [isLoading, setIsLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleStatusChange = async () => {
    await updateBlogPostStatus(blogPost.id, status.value, {
      label: "Status ändern",
      setIsLoading,
    });

    if (onStatusChange) onStatusChange(status);
  };

  // if (
  //   !(
  //     user.role_names.includes("sysadmin") ||
  //     user.role_names.includes("accredo")
  //   )
  // ) {
  //   return null; // Keine Berechtigung, den Status zu ändern
  // }

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="flex-end"
    >
      <Box>
        <BlogPostStatusBadge
          status={status.value}
          label={status.label}
          onClick={(e) => handleMenuOpen(e)}
          open={Boolean(anchorEl)}
          disabled={isLoading}
          ariaLabelledby="blogPost-state-label"
        />

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          {(statusOptions || []).map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              onClick={(e) => {
                setStatus(option);
                handleMenuClose();
              }}
            >
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  display: "inline-block",
                  marginRight: 1,
                }}
              />
              {option.label}
            </MenuItem>
          ))}
        </Menu>
      </Box>

      {status.value !== currentStatusObject?.value && (
        <Box marginLeft={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleStatusChange}
            disabled={isLoading}
            size="small"
          >
            {isLoading ? "Wird gespeichert..." : "Status ändern"}
          </Button>
        </Box>
      )}
    </Box>
  );
}
